import { createSelector } from 'reselect';

const selectSettings = state => state.settings;

/*
Outage status selector
*/

const getOutageStatus = (
  settings
) => {
  const { outageStatus = {} } = settings;
  const {
    enabled = false,
    info_url = '',
    info_url_text = '',
    message = '',
  } = outageStatus;

  return {
    enabled,
    info_url,
    info_url_text,
    message,
  };
};

export const outageStatusSelector =
  createSelector([
    selectSettings,
  ], getOutageStatus);
